export default "__VITE_PUBLIC_ASSET__72b31697__"